/*
 * Collection and reqres for the survey comments belonging to a single topic
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, Properties, SortableListModel) {
  const SurveyCommentsModel = {};

  function redactComment(options) {
    const { comment, time, touchpointId, localeId, rating, topicId } = options;
    const model = new SurveyCommentsModel.surveyComment();
    model.set({
      comment: comment,
      deleted: false,
      time: time,
      touchPointId: touchpointId,
      localeId: localeId,
      rating: rating,
      topicId: topicId,
    });
    return model.saveModelPromise();
  }

  SurveyCommentsModel.redactComment = redactComment;

  SurveyCommentsModel.surveyComment = Backbone.Model.extend({
    isNew: function () {
      // Always return false, so that if the comment is deleted the proper server call is made
      return false;
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/survey/comments/" +
        (this.get("date") || this.get("time")) +
        "/" +
        (this.get("touchpoint") || this.get("touchPointId")) +
        "/" +
        this.get("localeId") +
        "/" +
        this.get("rating") +
        "/" +
        (this.get("intentId") || this.get("topicId"))
      );
    },
    // Function to deleteComment from outside of initial SurveyCommentModel
    deleteComment: function (time, touchpoint, language, surveyChoice, topicId, callback) {
      const model = new SurveyCommentsModel.surveyComment();
      const kbId = Messenger.reqres.request("active:kb");
      model.url =
        Properties.rootURL +
        "/" +
        kbId +
        "/survey/comments/" +
        time +
        "/" +
        touchpoint +
        "/" +
        language +
        "/" +
        surveyChoice +
        "/" +
        topicId;
      model.destroy({
        success: callback,
      });
    },
  });

  SurveyCommentsModel.surveyComments = Backbone.Collection.extend({
    model: SurveyCommentsModel.surveyComment,
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/reports/surveyComments/" +
        this.startDate +
        "/" +
        this.endDate +
        "/" +
        this.surveyChoice +
        "/" +
        this.topicId +
        "?touchPointIds=" +
        this.touchPoints +
        "&localeIds=" +
        this.language
      );
    },
  });

  Messenger.reqres.setHandler(
    "survey:comments:headers",
    function (deleteComments) {
      if (deleteComments) {
        const redactTitle = $.t("reports.surveyDrilldown.redactComment");
        const deleteTitle = $.t("reports.surveyDrilldown.deleteComment");
        const toolHtml = `
<% if (!deleted) { %>
<button id="redactComment" type="button" class="btn btn-mini" title="${redactTitle}">
  <i class="icon-eraser"></i>
</button>
<button id="deleteComment" type="button" class="btn btn-danger btn-mini" title="${deleteTitle}">
  <i class="icon-remove"></i>
</button>
<% } %>
`;
        return new SortableListModel.headerCollection([
          {
            headerName: $.t("reports.surveyDrilldown.comment"),
            modelAttribute: "comment",
            longTextField: true,
            sortable: true,
            filterable: true,
          },
          {
            headerName: $.t("history.date"),
            modelAttribute: "time",
            dateField: true,
            sortable: true,
            filterable: false,
          },
          {
            headerName: "",
            modelAttribute: "deleted",
            width: "70px",
            customHtml: toolHtml,
          },
        ]);
      } else {
        return new SortableListModel.headerCollection([
          {
            headerName: $.t("reports.surveyDrilldown.comment"),
            modelAttribute: "comment",
            longTextField: true,
            sortable: true,
            filterable: true,
          },
          {
            headerName: $.t("history.date"),
            modelAttribute: "time",
            dateField: true,
            sortable: true,
            filterable: false,
          },
        ]);
      }
    },
    this,
  );

  Messenger.reqres.setHandler(
    "survey:comments",
    function (startDate, endDate, touchPoints, language, surveyChoice, topicId) {
      const comments = new SurveyCommentsModel.surveyComments();
      comments.startDate = startDate;
      comments.endDate = endDate;
      comments.touchPoints = touchPoints;
      comments.language = language;
      comments.surveyChoice = surveyChoice;
      comments.topicId = topicId;
      comments.fetch();
      return comments;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "create:survey:comment",
    function () {
      return new SurveyCommentsModel.surveyComment();
    },
    this,
  );

  Messenger.reqres.setHandler("redact:survey:comment", redactComment);

  return SurveyCommentsModel;
});
